function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }

  return receiver;
}

var id = 0;

function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}

var Emitter = require('component-emitter');

var has = require('@uppy/utils/lib/hasProperty');

var NetworkError = require('@uppy/utils/lib/NetworkError');

var fetchWithNetworkError = require('@uppy/utils/lib/fetchWithNetworkError');

var parseUrl = require('./parseUrl'); // Lazy load socket.io to avoid a console error
// in IE 10 when the Transloadit plugin is not used.
// (The console.error call comes from `buffer`. I
// think we actually don't use that part of socket.io
// at all…)


var socketIo;

function requireSocketIo() {
  var _socketIo; // eslint-disable-next-line global-require


  (_socketIo = socketIo) != null ? _socketIo : socketIo = require('socket.io-client');
  return socketIo;
}

var ASSEMBLY_UPLOADING = 'ASSEMBLY_UPLOADING';
var ASSEMBLY_EXECUTING = 'ASSEMBLY_EXECUTING';
var ASSEMBLY_COMPLETED = 'ASSEMBLY_COMPLETED';
var statusOrder = [ASSEMBLY_UPLOADING, ASSEMBLY_EXECUTING, ASSEMBLY_COMPLETED];
/**
 * Check that an assembly status is equal to or larger than some desired status.
 * It checks for things that are larger so that a comparison like this works,
 * when the old assembly status is UPLOADING but the new is FINISHED:
 *
 * !isStatus(oldStatus, ASSEMBLY_EXECUTING) && isStatus(newState, ASSEMBLY_EXECUTING)
 *
 * …so that we can emit the 'executing' event even if the execution step was so
 * fast that we missed it.
 */

function isStatus(status, test) {
  return statusOrder.indexOf(status) >= statusOrder.indexOf(test);
}

var _onFinished = /*#__PURE__*/_classPrivateFieldLooseKey("onFinished");

var _connectSocket = /*#__PURE__*/_classPrivateFieldLooseKey("connectSocket");

var _onError = /*#__PURE__*/_classPrivateFieldLooseKey("onError");

var _beginPolling = /*#__PURE__*/_classPrivateFieldLooseKey("beginPolling");

var _fetchStatus = /*#__PURE__*/_classPrivateFieldLooseKey("fetchStatus");

var _diffStatus = /*#__PURE__*/_classPrivateFieldLooseKey("diffStatus");

var TransloaditAssembly = /*#__PURE__*/function (_Emitter) {
  _inherits(TransloaditAssembly, _Emitter);

  var _super = _createSuper(TransloaditAssembly);

  function TransloaditAssembly(assembly) {
    var _this;

    _classCallCheck(this, TransloaditAssembly);

    _this = _super.call(this); // The current assembly status.

    Object.defineProperty(_assertThisInitialized(_this), _diffStatus, {
      value: _diffStatus2
    });
    Object.defineProperty(_assertThisInitialized(_this), _fetchStatus, {
      value: _fetchStatus2
    });
    Object.defineProperty(_assertThisInitialized(_this), _beginPolling, {
      value: _beginPolling2
    });
    Object.defineProperty(_assertThisInitialized(_this), _onError, {
      value: _onError2
    });
    Object.defineProperty(_assertThisInitialized(_this), _connectSocket, {
      value: _connectSocket2
    });
    Object.defineProperty(_assertThisInitialized(_this), _onFinished, {
      value: _onFinished2
    });
    _this.status = assembly; // The socket.io connection.

    _this.socket = null; // The interval timer for full status updates.

    _this.pollInterval = null; // Whether this assembly has been closed (finished or errored)

    _this.closed = false;
    return _this;
  }

  _createClass(TransloaditAssembly, [{
    key: "connect",
    value: function connect() {
      _classPrivateFieldLooseBase(this, _connectSocket)[_connectSocket]();

      _classPrivateFieldLooseBase(this, _beginPolling)[_beginPolling]();
    }
  }, {
    key: "update",
    value: function update() {
      return _classPrivateFieldLooseBase(this, _fetchStatus)[_fetchStatus]({
        diff: true
      });
    }
    /**
     * Update this assembly's status with a full new object. Events will be
     * emitted for status changes, new files, and new results.
     *
     * @param {object} next The new assembly status object.
     */

  }, {
    key: "updateStatus",
    value: function updateStatus(next) {
      _classPrivateFieldLooseBase(this, _diffStatus)[_diffStatus](this.status, next);

      this.status = next;
    }
    /**
     * Diff two assembly statuses, and emit the events necessary to go from `prev`
     * to `next`.
     *
     * @param {object} prev The previous assembly status.
     * @param {object} next The new assembly status.
     */

    /**
     * Stop updating this assembly.
     */

  }, {
    key: "close",
    value: function close() {
      this.closed = true;

      if (this.socket) {
        this.socket.disconnect();
        this.socket = null;
      }

      clearInterval(this.pollInterval);
      this.pollInterval = null;
    }
  }]);

  return TransloaditAssembly;
}(Emitter);

function _onFinished2() {
  this.emit('finished');
  this.close();
}

function _connectSocket2() {
  var _this2 = this;

  var parsed = parseUrl(this.status.websocket_url);
  var socket = requireSocketIo().connect(parsed.origin, {
    transports: ['websocket'],
    path: parsed.pathname
  });
  socket.on('connect', function () {
    socket.emit('assembly_connect', {
      id: _this2.status.assembly_id
    });

    _this2.emit('connect');
  });
  socket.on('connect_error', function () {
    socket.disconnect();
    _this2.socket = null;
  });
  socket.on('assembly_finished', function () {
    _classPrivateFieldLooseBase(_this2, _onFinished)[_onFinished]();
  });
  socket.on('assembly_upload_finished', function (file) {
    _this2.emit('upload', file);

    _this2.status.uploads.push(file);
  });
  socket.on('assembly_uploading_finished', function () {
    _this2.emit('executing');
  });
  socket.on('assembly_upload_meta_data_extracted', function () {
    _this2.emit('metadata');

    _classPrivateFieldLooseBase(_this2, _fetchStatus)[_fetchStatus]({
      diff: false
    });
  });
  socket.on('assembly_result_finished', function (stepName, result) {
    _this2.emit('result', stepName, result);

    if (!_this2.status.results[stepName]) {
      _this2.status.results[stepName] = [];
    }

    _this2.status.results[stepName].push(result);
  });
  socket.on('assembly_error', function (err) {
    _classPrivateFieldLooseBase(_this2, _onError)[_onError](err); // Refetch for updated status code


    _classPrivateFieldLooseBase(_this2, _fetchStatus)[_fetchStatus]({
      diff: false
    });
  });
  this.socket = socket;
}

function _onError2(err) {
  this.emit('error', Object.assign(new Error(err.message), err));
  this.close();
}

function _beginPolling2() {
  var _this3 = this;

  this.pollInterval = setInterval(function () {
    if (!_this3.socket || !_this3.socket.connected) {
      _classPrivateFieldLooseBase(_this3, _fetchStatus)[_fetchStatus]();
    }
  }, 2000);
}

function _fetchStatus2(_x) {
  return _fetchStatus3.apply(this, arguments);
}

function _fetchStatus3() {
  _fetchStatus3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_temp) {
    var _ref, _ref$diff, diff, response, status;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref = _temp === void 0 ? {} : _temp, _ref$diff = _ref.diff, diff = _ref$diff === void 0 ? true : _ref$diff;

            if (!this.closed) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return");

          case 3:
            _context.prev = 3;
            _context.next = 6;
            return fetchWithNetworkError(this.status.assembly_ssl_url);

          case 6:
            response = _context.sent;

            if (!this.closed) {
              _context.next = 9;
              break;
            }

            return _context.abrupt("return");

          case 9:
            if (!(response.status === 429)) {
              _context.next = 11;
              break;
            }

            return _context.abrupt("return");

          case 11:
            if (response.ok) {
              _context.next = 14;
              break;
            }

            _classPrivateFieldLooseBase(this, _onError)[_onError](new NetworkError(response.statusText));

            return _context.abrupt("return");

          case 14:
            _context.next = 16;
            return response.json();

          case 16:
            status = _context.sent;

            if (!this.closed) {
              _context.next = 19;
              break;
            }

            return _context.abrupt("return");

          case 19:
            this.emit('status', status);

            if (diff) {
              this.updateStatus(status);
            } else {
              this.status = status;
            }

            _context.next = 26;
            break;

          case 23:
            _context.prev = 23;
            _context.t0 = _context["catch"](3);

            _classPrivateFieldLooseBase(this, _onError)[_onError](_context.t0);

          case 26:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[3, 23]]);
  }));
  return _fetchStatus3.apply(this, arguments);
}

function _diffStatus2(prev, next) {
  var _this4 = this;

  var prevStatus = prev.ok;
  var nextStatus = next.ok;

  if (next.error && !prev.error) {
    return _classPrivateFieldLooseBase(this, _onError)[_onError](next);
  } // Desired emit order:
  //  - executing
  //  - (n × upload)
  //  - metadata
  //  - (m × result)
  //  - finished
  // The below checks run in this order, that way even if we jump from
  // UPLOADING straight to FINISHED all the events are emitted as expected.


  var nowExecuting = isStatus(nextStatus, ASSEMBLY_EXECUTING) && !isStatus(prevStatus, ASSEMBLY_EXECUTING);

  if (nowExecuting) {
    // Without WebSockets, this is our only way to tell if uploading finished.
    // Hence, we emit this just before the 'upload's and before the 'metadata'
    // event for the most intuitive ordering, corresponding to the _usual_
    // ordering (if not guaranteed) that you'd get on the WebSocket.
    this.emit('executing');
  } // Find new uploaded files.


  Object.keys(next.uploads).filter(function (upload) {
    return !has(prev.uploads, upload);
  }).forEach(function (upload) {
    _this4.emit('upload', next.uploads[upload]);
  });

  if (nowExecuting) {
    this.emit('metadata');
  } // Find new results.


  Object.keys(next.results).forEach(function (stepName) {
    var nextResults = next.results[stepName];
    var prevResults = prev.results[stepName];
    nextResults.filter(function (n) {
      return !prevResults || !prevResults.some(function (p) {
        return p.id === n.id;
      });
    }).forEach(function (result) {
      _this4.emit('result', stepName, result);
    });
  });

  if (isStatus(nextStatus, ASSEMBLY_COMPLETED) && !isStatus(prevStatus, ASSEMBLY_COMPLETED)) {
    this.emit('finished');
  }

  return undefined;
}

module.exports = TransloaditAssembly;